import { TModal } from '@variantjs/vue';

const styles = {
    overlay: [
        '-modal-overlay',
        'bg-overlay',
        'bg-opacity-75',
        'z-semi',
    ],

    wrapper: [
        '-modal-wrapper',
        'pt-100px',
        'pb-40px',
        'px-15px',
        'z-full',
    ],

    modal: [
        '-modal-content',
        'bg-neutral-high_pure',
        'rounded-low',
        'shadow-03',
        'mobile:shadow-01',
    ],

    body: [
        '-modal-body',
        'px-38px pt-30px pb-55px',
        'flex',
        'flex-col',
        'mobile:px-30px',
    ],

    overlayEnterClass: 'opacity-0',
    overlayEnterActiveClass: 'transition ease-out duration-100',
    overlayEnterToClass: 'opacity-100',
    overlayLeaveClass: 'opacity-100',
    overlayLeaveActiveClass: 'transition ease-in duration-75',
    overlayLeaveToClass: 'opacity-0',
};

const settings = {
    TModal: {
        component: TModal,
        props: {
            classes: styles,
        },
    },
};

export default settings;
